import axios from '../../v2/app/services/axiosService';
import localforage from 'localforage';

localforage.setDriver(localforage.LOCALSTORAGE);
const SUBDOMAIN_KEY = 'dynamics_subdomain';
const DOMAIN_KEY = 'dynamics_domain';

function checkError(err) {
  if (err && err.response) {
    if (err.response.status === 401) {
      //toastr.error('Your Dynamics session has expired. You have to login to Dynamics.', 'Dynamics Session Expired');
      app.$router.push({name: 'dynamics.login_required', query: {redirect_to: window.location.pathname}});
      return;
    }
  }
  throw err;
}

export default {
  async getSavedDomain() {
    let subdomain = null;
    let domain = null;
    subdomain = await localforage.getItem(SUBDOMAIN_KEY);
    domain = await localforage.getItem(DOMAIN_KEY);
    return {
      subdomain: subdomain,
      domain: domain,
    }
  },
  async saveDomain(subdomain, domain) {
    return await Promise.all([
      localforage.setItem(SUBDOMAIN_KEY, subdomain),
      localforage.setItem(DOMAIN_KEY, domain)
    ])
  },
  async getAccounts() {
    try {
      const response = await axios.get(`/api/dynamics/accounts`);
      return response.data;
    } catch (err) {
      return checkError(err);
    }
  },
  async getAccount(accountID) {
    try {
      const response = await axios.get(`/api/dynamics/accounts/${accountID}`);
      return response.data;
    } catch (err) {
      return checkError(err);
    }
  },
  async getContacts() {
    try {
      const response = await axios.get(`/api/dynamics/contacts`);
      return response.data;
    } catch (err) {
      return checkError(err);
    }
  },
  async getContact(contactID) {
    try {
      const response = await axios.get(`/api/dynamics/contacts/${contactID}`);
      return response.data;
    } catch (err) {
      return checkError(err);
    }
  },
  async getUsers() {
    try {
      const response = await axios.get(`/api/dynamics/users`);
      return response.data;
    } catch (err) {
      return checkError(err);
    }
  }
}
